import AutomationRuleList from './AutomationRuleList'
import AutomationRuleCreate from './AutomationRuleCreate'
import AutomationRuleEdit from './AutomationRuleEdit'
import AutomationRuleShow from './AutomationRuleShow'
import BoltIcon from '@mui/icons-material/Bolt'

export default {
  list: AutomationRuleList,
  create: AutomationRuleCreate,
  edit: AutomationRuleEdit,
  show: AutomationRuleShow,
  icon: BoltIcon,
}
